import * as React from 'react'
import { useEffect } from 'react'
import { Switch, Route, Redirect } from 'react-router'
import { connect } from 'react-redux'
import { getExtendedUser } from '../../redux/actions'

import Preloader from '../../components/prealoder/Preloader'
import ResourceCatalogContainer from '../resourceCatalog/ResourceCatalogContainer'
import './CobaltLayout.css'

const CobaltLayout: React.FC = (props: any) => {
  const { user, getExtendedUser, preloader, allowRender } = props

  useEffect(() => {
    if (user && user.access_token) {
      getExtendedUser(user.access_token)
    }
  }, [user, getExtendedUser])

  return (
    <div>
      {preloader.visible ? (
        <Preloader />
      ) : (
        allowRender && (
          <div className="App">
            <div className="app-body">
              <Switch>
                <Route exact path="/">
                  <Redirect to="/resource" />
                </Route>
                <Route path="/resource" component={ResourceCatalogContainer} />
              </Switch>
            </div>
          </div>
        )
      )}
    </div>
  )
}

function mapStateToProps(state: any) {
  return {
    user: state.oidc.user,
    preloader: state.preloader,
    profile: state.user.user,
    allowRender: state.user.isAccessAuthorized,
  }
}

export default connect(mapStateToProps, { getExtendedUser })(CobaltLayout)
